export enum AbsenceView {
  table = 'table',
  calendar = 'calendar',
  requests = 'requests',
  gantt = 'gantt',
}

export const absenceViewValues = [
  AbsenceView.table,
  AbsenceView.calendar,
  AbsenceView.requests,
  AbsenceView.gantt,
] as const

export enum AbsenceStatusValue {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export type TimeEntryView = keyof typeof TimeEntryViewEnum

export enum TimeEntryViewEnum {
  monthly = 'monthly',
  weekly = 'weekly',
}

export const timeEntryViewValues = [
  TimeEntryViewEnum.monthly,
  TimeEntryViewEnum.weekly,
] as const

export enum TimeEntyOvertimeValue {
  FIFTY = 'FIFTY',
  HUNDRED = 'HUNDRED',
}
